import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cw-not-implemented',
  templateUrl: './not-implemented.component.html'
})
export class NotImplementedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/not-implemented/not-implemented.component.ts